import formatCurrency from "./formatCurrency";

export default function formatCreditUsage(max: number, consumed: number) {
  if (max === 0 && consumed === 0) {
    return "";
  }
  return `${formatCurrency(consumed)} / ${formatCurrency(max)}`;
}
